var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90229 8.07584V4.94123C4.90229 3.50878 6.06771 2.34328 7.50024 2.34328C8.93278 2.34328 10.0982 3.5087 10.0982 4.94123V8.07584H12.4414V4.94116C12.4414 2.21226 10.2292 0 7.50024 0C4.77127 0 2.55908 2.21219 2.55908 4.94116V8.07584H4.90229Z",
    fill: "#2F373B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8832 8.07601V4.94133C3.8832 2.43709 5.74661 0.369334 8.1623 0.04566C7.94561 0.0166211 7.7249 0.000244141 7.50024 0.000244141C4.77135 0.000244141 2.55908 2.21243 2.55908 4.9414V8.07609H3.8832V8.07601Z",
    fill: "#151E22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5424 18H1.45761C1.02619 18 0.676514 17.6503 0.676514 17.2189V8.78109C0.676514 8.34968 1.02619 8 1.45761 8H13.5424C13.9738 8 14.3235 8.34968 14.3235 8.78109V17.2189C14.3235 17.6503 13.9737 18 13.5424 18Z",
    fill: "#FAC600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96109 17.2189V8.78109C3.96109 8.34968 4.31077 8 4.74219 8H1.45761C1.02619 8 0.676514 8.34968 0.676514 8.78109V17.2189C0.676514 17.6503 1.02619 18 1.45761 18H4.74219C4.31077 18 3.96109 17.6503 3.96109 17.2189Z",
    fill: "#E8B800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a1b7b91fe2ad089edcedc744b1ec1966.svg";
export { ForwardRef as ReactComponent };